'use strict';
angular.module('editFusionPreviewModule', [])
    .controller('editFusionPreviewCtrl', ['$scope', '$state', '$stateParams', '$element', '$controller', '$compile', '$q', '$templateRequest', 'trsHttpService',
        function ($scope, $state, $stateParams, $element, $controller, $compile, $q, $templateRequest, trsHttpService) {
            var pagesInfo = {};
            initStatus();

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.data = {
                    navs: [],
                    selectTimes: 0, // 2 储存公共信息
                    publicInfo: ''
                };
                getChannel();
            }

            /**
             * [getChannel description] 获取关联渠道
             * @return {[type]} [description]
             */
            function getChannel() {
                if ($stateParams.iwotype != '8') {
                    $scope.data.navs.push({
                        MEDIANAME: '基础稿',
                        MEDIATYPE: '-1',
                        routerName: 'iwopreview'
                    });
                }
                if ($stateParams.mlftype == 0 || !$stateParams.mlftype) {
                    getBindingMediaIds($stateParams.iwometadataid).then(function (bingdingData) {
                        angular.forEach(bingdingData, function (value, key) {
                            if (value.MEDIATYPE == '1') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    routerName: 'appPreview'
                                });
                            } else if (value.MEDIATYPE == '2') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    routerName: 'websitePreviewAll'
                                });
                            } else if (value.MEDIATYPE == '3') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    routerName: 'newspaperNewsPreview'
                                });
                            } else if (value.MEDIATYPE == '4') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    routerName: 'weixinPreview'
                                });
                            } else if (value.MEDIATYPE == '5') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    routerName: 'wbPreview'
                                });
                            } else if (value.MEDIATYPE == '18') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    // metadataid: value
                                    // routerName: 'baijiahaoPreviewAll'
                                    routerName: 'newMediaPreview',
                                });
                            } else if (value.MEDIATYPE == '19') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    routerName: 'newMediaPreview',
                                });
                            } else if (value.MEDIATYPE == '20') {
                                $scope.data.navs.push({
                                    MEDIANAME: value.MEDIANAME,
                                    MEDIATYPE: value.MEDIATYPE,
                                    // routerName: 'toutiaohaoPreviewAll'
                                    routerName: 'newMediaPreview',
                                });
                            }
                        });
                        selectNav($scope.data.navs[0]);
                    });
                } else {
                    selectNav($scope.data.navs[0]);
                }
            }

            /**
             * [getBindingMediaIds description] 获取绑定的渠道的相关id
             * @param {[type]} [iwometadataid] [description] iwo稿件id
             * @return {[type]} [description]
             */
            function getBindingMediaIds(iwometadataid) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryFuseMappings',
                    sourceDocId: iwometadataid,
                    mediaTypes: ''
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }


            /**
             * [selectNav description] 页面选择导航
             * @param  {[type]} nav [description] 当前导航数据
             * @return {[type]}     [description]
             */
            $scope.selectNav = function (nav) {
                $state.params.mediatype = nav.MEDIATYPE;
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                selectNav(nav);
            };

            /**
             * [selectNav description] 选择导航
             * @param  {[type]} nav [description] 当前导航数据
             * @return {[type]}     [description]
             */
            function selectNav(nav) {
                $scope.data.selectTimes++;
                if (!!$scope.data.selectedNav) {
                    if ($scope.data.selectTimes == 2) {
                        saveList();
                    }
                    destroyController();
                    $scope.data.isSave = !$scope.data.isSave;
                }
                $scope.data.selectedNav = nav;
                var navInfo = $state.get(nav.routerName).views['']; // 路由模板
                var templateUrl = navInfo.templateUrl;
                getTemplate(templateUrl, nav.routerName).then(function ($template) {
                    var controller = {};
                    controller.$scope = $scope.$new();
                    controller.$element = $template;
                    $controller(navInfo.controller, controller);
                    $template = $compile($template)(controller.$scope);
                    $element.find('.main').html($template);
                    $scope.data.selectedNav.controller = controller; // prev
                    if (nav.MEDIATYPE != '-1' && $scope.data.selectTimes >= 2) {
                        $scope.data.selectedNav.controller.$scope.list = $scope.data.publicInfo; // 公用字段
                    }
                });
            }


            /**
             * [destroyController description] 销毁控制器
             * @return {[type]} [description]
             */
            function destroyController() {
                $scope.data.selectedNav.controller.$scope.$destroy();
            }

            /**
             * [saveList description] 切换时保存list数据
             * @return {[type]}     [description]
             */
            function saveList() {
                $scope.data.publicInfo = angular.copy($scope.data.selectedNav.controller.$scope.list);
            }

            /**
             * [getTemplate description] 获取模板
             * @param {string} [templateUrl] [description] 模板地址
             * @param {string} [pageName] [description] 模板名称
             * @return {[type]} [description]
             */
            function getTemplate(templateUrl, pageName) {
                var deffer = $q.defer();
                if (!!pagesInfo[pageName]) {
                    deffer.resolve(pagesInfo[pageName].$template.clone());
                    return deffer.promise;
                }
                $templateRequest(templateUrl).then(function (template) {
                    var $dom = $(template);
                    pagesInfo[pageName] = {
                        $template: $dom
                    };
                    deffer.resolve(pagesInfo[pageName].$template.clone());
                });
                return deffer.promise;
            }
        }
    ]);
